import { setupNextraPage } from 'nextra/setup-page'
import __nextra_layout from 'nextra-theme-docs'
import __nextra_themeConfig from '/vercel/path0/theme.config.tsx'

import 'nextra-theme-docs/style.css'
/*@jsxRuntime automatic @jsxImportSource react*/
/*Import CSS modules*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
import InitMenu from '../src/components/InitMenu';
import {useState} from "react";
import styles from '../src/components/Counter/index.module.css';
export const Counter = () => {
  const _components = Object.assign({
    div: "div",
    button: "button"
  }, _provideComponents());
  const [count, setCount] = useState(0);
  return <_components.div>
      <_components.button onClick={() => setCount(count + 1)} className={styles.counter}>Clicked {count} times</_components.button>
    </_components.div>;
};
import MyCounter from '../src/components/Counter';
import Date from 'funda-ui/Date';
import 'funda-ui/Date/index.css';
export const __toc = [{
  depth: 2,
  value: "Collapsible Section",
  id: "collapsible-section"
}, {
  depth: 2,
  value: "Component 1",
  id: "component-1"
}, {
  depth: 2,
  value: "Component 2",
  id: "component-2"
}, {
  depth: 2,
  value: "External Component",
  id: "external-component"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    pre: "pre",
    code: "code",
    span: "span",
    h2: "h2",
    details: "details",
    summary: "summary"
  }, _provideComponents(), props.components);
  return <><InitMenu />{"\n"}<_components.h1>{"Another Page"}</_components.h1>{"\n"}<_components.pre data-language="js" data-theme="default" filename="demo.js" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"let"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" a "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line highlighted"><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(a);"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.h2 id="collapsible-section">{"Collapsible Section"}</_components.h2>{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default"><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"let"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" a "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(a);"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="component-1">{"Component 1"}</_components.h2>{"\n"}{"\n"}{}{"\n"}{"\n"}{"\n"}<Counter />{"\n"}<_components.h2 id="component-2">{"Component 2"}</_components.h2>{"\n"}{"\n"}<MyCounter />{"\n"}<_components.h2 id="external-component">{"External Component"}</_components.h2>{"\n"}{"\n"}{"\n"}<br />{"\n"}<Date name="name" label="Date" value="2024-03-13" type="date" placeholder="yyyy/MM/dd" />{"\n"}<Date name="name" label="Date & Time (no seconds)" value="2024-03-14 10:22" type="datetime-local" placeholder="yyyy/MM/dd HH:mm" truncateSeconds /></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}



const __nextraPageOptions = {
  MDXContent,
  pageOpts: {"filePath":"pages/another.html.mdx","route":"/another.html","timestamp":1723000581000,"pageMap":[{"kind":"Folder","name":"Folder-1","route":"/Folder-1","children":[{"kind":"Meta","data":{"satori.html":"Satori Title"}},{"kind":"MdxPage","name":"satori.html","route":"/Folder-1/satori.html"}]},{"kind":"Folder","name":"Folder-2","route":"/Folder-2","children":[{"kind":"Meta","data":{"demo.html":"Demo Title"}},{"kind":"MdxPage","name":"demo.html","route":"/Folder-2/demo.html"}]},{"kind":"Meta","data":{"index":"Introduction","--":{"type":"separator","title":"A Separator"},"another.html":"Another Page","Folder-1":"","Folder-2":"","about.html":{"title":"About","type":"page"},"contact":{"title":"Source ↗","type":"page","href":"https://github.com/xizon/nextjs-doc-template","newWindow":true}}},{"kind":"MdxPage","name":"about.html","route":"/about.html"},{"kind":"MdxPage","name":"another.html","route":"/another.html"},{"kind":"MdxPage","name":"index","route":"/"}],"flexsearch":{"codeblocks":true},"title":"Another Page",headings:__toc},
  pageNextRoute: "/another.html",
  nextraLayout: __nextra_layout,themeConfig: __nextra_themeConfig
}
if (process.env.NODE_ENV !== 'production') {
  __nextraPageOptions.hot = module.hot
  __nextraPageOptions.pageOptsChecksum = ''
}
if (typeof window === 'undefined') __nextraPageOptions.dynamicMetaModules = []

export default setupNextraPage(__nextraPageOptions)